var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Select',{attrs:{"name":_vm.name,"options":_vm.options,"multiple":true,"placeholder":_vm.placeholder,"searchable":true,"reduce":item => item.value,"rules":_vm.rules,"disabled":_vm.disabled},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }